/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { ReactComponent as Wave } from "../../wave.svg";

const Water = props => {
  let { height, progress, opacity } = props;

  if (opacity === undefined) {
    opacity = 1;
  }

  if (progress === undefined) {
    progress = 1;
  }

  let heightProgress = 0;
  heightProgress = height - 8 - height * progress;
  // if (progress === 1) {
  //   heightProgress = height;
  // } else {
  //   heightProgress = height - 8 - height * progress;
  // }
  const waterCss = css`
    position: absolute;
    top: 0px;
    width: 100%;
    height: ${height}px;
    overflow: hidden;
    backface-visibility: hidden;
    transform: translate3d(0, 0, 0);
    > div {
      transform: translate(0, ${heightProgress}px);
      /* transition: opacity 0.7s ease-in-out; */
      transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out,
        -webkit-transform 0.2s ease-in-out;
      opacity: ${progress === 1 ? 0 : opacity};
    }
    svg {
      animation-name: waveAction;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
      animation-duration: 1.5s;
      fill: #04acff;
    }
    @keyframes waveAction {
      0% {
        transform: translate(-143px, 0);
      }
      100% {
        transform: translate(0, 0);
      }
    }
  `;
  return (
    <div css={waterCss}>
      <div>
        <Wave />
      </div>
    </div>
  );
};

export default Water;
